import React, { useCallback, useState } from "react";
import { useGetLMCUserProfile } from "../../hooks/entity";
import LoyaltyCardContainer from "../atoms/LoyaltyCardContainer";
import LmcUserReward from "../pages/lmcUserVIew/LmcUserReward";
import { useLmcUserView } from "../../contexts/AuthContext";
import LmcVerifyEmail from "../pages/lmcUserVIew/components/LmcVerifyEmail";
import { Spinner } from "../atoms/Spinner";
import { CustomButton } from "../atoms/CustomButton";
import { useTranslation } from "react-i18next";
import LmcDashboard from "../pages/lmcUserVIew/LmcDashboard";
import LmcUserViewSettings from "../pages/lmcUserVIew/LmcUserViewSettings";
import { toast } from "react-toastify";

export type {
  LoyaltyProgramType,
  LoyaltyCardTemplate,
  LoyaltyCardProps,
  LoyaltyCardPresentationProps,
} from "../../types/LoyaltyCardTypes";

const LoyaltyDashboardRenderer: React.FC<any> = ({
  ProcessId,
}: {
  ProcessId: string;
}) => {
  const { t } = useTranslation("clientView");
  const [isFlipping, setIsFlipping] = useState(false);
  const [showBackFace, setShowBackFace] = useState(false);

  const [userInfo, setUserInfo] = useState({
    user_email: "",
    user_identification: "",
  });
  const [showConfirmEmail, setShowConfirmEmail] = useState<boolean>(false);

  const [showCardDetail, setShowCardDetail] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const {
    state: { auth, entity },
    dispatch,
  } = useLmcUserView();

  const { isLoading, isError, refetch } = useGetLMCUserProfile(
    entity?.entity_data?.entity_identification as string,
    auth.user_identification as string,
    {
      onSuccess: (payload) => {
        dispatch({
          type: "LMCDATA",
          payload,
        });

        if (!payload?.user?.is_active) {
          setUserInfo({
            user_email: payload?.user?.email,
            user_identification: auth?.user_identification || "",
          });
          toast.warn(t("login.notActive"));
        }

        setShowConfirmEmail(!payload?.user?.is_active);
      },
    }
  );

  const handleFlipToBack = useCallback(() => {
    if (isFlipping) return;
    setIsFlipping(true);
    window.setTimeout(() => setShowBackFace(true), 280);
    window.setTimeout(() => setIsFlipping(false), 600);
  }, [isFlipping]);

  const handleFlipToFront = useCallback(() => {
    if (isFlipping) return;
    setIsFlipping(true);
    window.setTimeout(() => {
      setShowBackFace(false);
      setShowCardDetail(false);
      setShowSettings(false);
    }, 280);
    window.setTimeout(() => setIsFlipping(false), 600);
  }, [isFlipping]);

  const frontContent = (
    <LmcDashboard
      handleFlipToBack={(type: "CARD_DETAIL" | "SETTINGS") => {
        if (type === "CARD_DETAIL") {
          setShowCardDetail(true);
        } else if (type === "SETTINGS") {
          setShowSettings(true);
        }
        handleFlipToBack();
      }}
    />
  );
  const backContent = showCardDetail ? (
    <LmcUserReward
      handleFlipToFront={() => {
        setShowCardDetail(false);
        handleFlipToFront();
      }}
    />
  ) : showSettings ? (
    <LmcUserViewSettings
      handleFlipToFront={() => {
        setShowSettings(false);
        handleFlipToFront();
      }}
    />
  ) : null;

  if (showConfirmEmail) {
    return (
      <LmcVerifyEmail
        userEmail={userInfo.user_email}
        userId={userInfo.user_identification}
        showConfirmEmailModal={showConfirmEmail}
        handleLogin={() => refetch()}
        isLoading={isLoading}
      />
    );
  }
  if (isLoading) {
    return (
      <div className="w-full min-h-[60vh] px-4 flex items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="w-full p-6 flex flex-col items-center gap-4">
        <h5 className="text-gray-200 text-center">{t("key4")}</h5>
        <CustomButton
          onClick={() => refetch()}
          title={t("key2") as string}
          variant="primary"
        />
      </div>
    );
  }

  return (
    <LoyaltyCardContainer
      frontContent={frontContent}
      backContent={backContent}
      isPreview={false}
      isFlipping={isFlipping}
      showEmailLogin={showBackFace}
      showForgotPasswordForm={false}
      onFlip={setShowBackFace}
      className="max-w-[360px] w-full"
      fullHeight={true}
    />
  );
};

export default LoyaltyDashboardRenderer;
